import 'bootstrap';
import _ from 'underscore';
import AlertListView from '../alert-list/index';
import template from './template.pug';

/**
 * Represents a carousel as a list of alerts
 */
export default class AlertCarouselView extends AlertListView {
  initialize({
    level,
    i18n,
  }) {
    this.i18n = i18n;
    this.carouselId = _.uniqueId('alert-carousel-');
    super.initialize({ level });
  }

  get template() {
    return template;
  }
}
